$(function () {
    $('iframe[src*="player.vimeo.com"]').each(function () {
        var $iframe = $(this);
        var ratio = $iframe.is('[width][height]')
            ? $iframe.attr('height') / $iframe.attr('width')
            : $iframe.outerHeight() / $iframe.outerWidth();

        $iframe.wrap('<div class="iframe-wrapper" style="padding-top:' + ratio*100 + '%;"></div>');
    });
});